import React from 'react';
import { get, each } from 'mori';
import Wahanda from 'common/wahanda';

type Constituent = {
  id: number;
  name: string;
};

interface IRowProps extends React.HTMLAttributes<Element> {
  name?: string;
  totalPrice?: number;
  unitPrice?: number;
  constituents?: {};
  quantity?: number;
  additionalClass?: string;
  negative?: boolean;
  hideZero?: boolean;
}

const Row: React.FC<IRowProps> = ({
  name,
  totalPrice,
  unitPrice,
  constituents,
  quantity,
  additionalClass,
  negative,
  hideZero,
}) => {
  const getQuantity = () => {
    if (quantity) {
      return (
        <span className="quantity">{`${quantity} x ${Wahanda.Currency.format(unitPrice, {
          forceDecimalPoint: true,
        })}`}</span>
      );
    }
    return null;
  };

  const getConstituents = () => {
    const constituentsList: React.ReactElement[] = [];
    each(constituents, (constituent: Constituent) => {
      constituentsList.push(
        <span className="constituent" key={get(constituent, 'id')}>
          {get(constituent, 'name')}
        </span>,
      );
    });
    return constituentsList;
  };
  const quantityElement = getQuantity();
  const classNames = `row ${additionalClass || ''}`;
  const constituentsList = getConstituents();
  const sign = negative ? <span className="negative-sign">-</span> : null;

  if (totalPrice === 0 && hideZero) {
    return null;
  }

  return (
    <div className={classNames}>
      <span className="name">{name}</span>
      <span className="total-price">
        {sign}
        {Wahanda.Currency.format(totalPrice, { forceDecimalPoint: true })}
      </span>
      {quantityElement}
      {constituentsList}
    </div>
  );
};

export default Row;
